import {ErrorHandler, NgModule} from '@angular/core';
import {Router} from "@angular/router";
import {BrowserModule, provideClientHydration} from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule, TranslatePipe} from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {environment} from "../../environments/environment";
import {isInBrowser} from "../utils/clientutils";
import {getRandomInt} from "../../../shared/utils";
import {FooterComponent} from "./main-pages/footer/footer.component";
import {MainPagesContainerComponent} from "./main-pages/main-pages-container/main-pages-container.component";

function initSentry() {
    Sentry.init({
        dsn: "https://80ed92b3d53545819f43caeba5722165@o1371022.ingest.sentry.io/6674896",
        integrations: [// Registers and configures the Tracing integration,
            // which automatically instruments your application to monitor its
            // performance, including custom Angular routing instrumentation
            Sentry.browserTracingIntegration(), // Registers the Replay integration,
            // which automatically captures Session Replays
            Sentry.replayIntegration(),
        ],
        release: environment.version,
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    })
}

function initGA() {
    let id = environment.gaId;

    let script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    document.head.appendChild(script);

    const wndw = window as any

    wndw.dataLayer = wndw.dataLayer || [];

    wndw.gtag = function (...args: any) {
        wndw.dataLayer.push(arguments);
    }

    wndw.gtag('js', new Date());

    wndw.gtag('config', id);
}

function initMetrika() {
    window.addEventListener("load", function () {
        (function (m, e, t, r, i, k, a) {
            m[i] = m[i] || function () {
                (m[i].a = m[i].a || []).push(arguments)
            };
            m[i].l = 1 * new Date().getDate();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
        })
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        (window as any).ym(54414226, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true
        });
    });
}

if (environment.production && getRandomInt(0, 100) <= 1) {
    initSentry()
}

if (isInBrowser()) {
    initGA();
    initMetrika()
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MatButtonModule,
        TranslateModule.forRoot({
            fallbackLang: environment.language
        }),
        FooterComponent,
        MainPagesContainerComponent,
        TranslatePipe
    ],
    providers: [
        provideClientHydration(),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService, deps: [Router],
        },
    ]
})
export class AppModule {
}


